import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";

import { failureActiveUserFilter, successActiveUserFilter } from "./ActiveUserFilter";
import { failureTestCompletedFilter, successTestCompletedFilter } from "./TestCompeletedFilter";
import { failureOverallActivityFilter, successOverallActivityFilter } from "./OverallActivityFilter";
import { failureGateAdminDashboardData, successGateAdminDashboardData } from "./Admindashboard";


// cards data
const GateAdminDashboardApi = () => {
  return api.get("/api/admin-dashboard/dashboard");
};

export function* GateAdminDashboardApiCall() {
  try {
    const response: AxiosResponse = yield call(GateAdminDashboardApi);
    yield put(successGateAdminDashboardData(response.data));
  } catch (error) {
    yield put(failureGateAdminDashboardData(error));
  }
}


const ActiveUserFilterApi = (action?: PayloadAction<any>) => {
  const FilterBy = action?.payload?.FilterBy;
  return api.get(`/api/admin-dashboard/active-users/${FilterBy}`, action?.payload);
};

export function* ActiveUserFilterCall(action?: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(ActiveUserFilterApi, action);
    yield put(successActiveUserFilter(response.data));
  } catch (error) {
    yield put(failureActiveUserFilter(error));
  }
}

const TestCompletedFilterApi = (action?: PayloadAction<any>) => {
  const FilterBy = action?.payload?.FilterBy;
  return api.get(`/api/admin-dashboard/test-completion/${FilterBy}`, action?.payload);
};

export function* TestCompletedFilterCall(action?: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(TestCompletedFilterApi, action);
    yield put(successTestCompletedFilter(response.data));
  } catch (error) {
    yield put(failureTestCompletedFilter(error));
  }
}


const OverallActivityFilterApi = (action?: PayloadAction<any>) => {
  const limit = action?.payload?.limit;
  return api.get(`/api/admin-dashboard/overall-activity/${limit}`, action?.payload);
};

export function* OverallActivityFilterCall(action?: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(OverallActivityFilterApi, action);
    yield put(successOverallActivityFilter(response.data));
  } catch (error) {
    yield put(failureOverallActivityFilter(error));
  }
}


